export const COLORS = {
  sidebarBg: "#fff",
  extraItemsBg: "#fff",
}

export const WIDTH = {
  expanded: 215,
  collapsed: 66,
}
